<template>
<div>
  <label  v-if="showProgress">Upload läuft…</label>
  <progress  v-if="showProgress" value="0" max="100" id="uploader" style="width: 100%; -webkit-appearance: none; appearance: none; height: 20px; margin-top: 5px; margin-bottom: 1em;"></progress>
  <!-- <progress v-if="showProgress" value="0" max="100" id="uploader" style="width: 100%;"></progress> -->
  <input accept="image/*" type="file" value="upload" ref="fileUpload" style="display:none;" class="hiddenUploader" v-if="uploadReady" @change="fileBtn($event)">
  <button v-if="!showProgress" class="btn--dashed" @click="setClick()"><svgicon icon="camera"  width="32" height="32" color="#000000"></svgicon> Bild hinzufügen</button>
</div>
</template>

<script>
import firebase from 'firebase'

export default {
  data () {
    return {
      uploadReady: true,
      showProgress: false
    }
  },
  methods: {
    fileBtn: function (e) {
      this.showProgress = true
      e.preventDefault()

      this.$nextTick(() => {
        const uploader = document.getElementById('uploader')

        let getFile = e.target.files[0]
        let fileref = 'imagedata/' + getFile.name + Math.floor(Math.random() * 1000)
        let storageRef = firebase.storage().ref(fileref)

        let task = storageRef.put(getFile)
        const self = this

        task.on('state_changed',
          function progress (snapshot) {
            let percentage = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            uploader.value = percentage
          },
          function error (err) {
            console.log(err)
          },
          function complete () {
            // console.log('complete upload')
            task.snapshot.ref.getDownloadURL().then(function (downloadURL) {
              self.$emit('imageAdded', downloadURL)
            })
            self.uploadReady = false
            uploader.value = 0
            self.$nextTick(() => {
              self.uploadReady = true
              self.showProgress = false
            })
          }
        )
      })
    },
    setClick: function () {
      this.$refs.fileUpload.click()
    }
  }
}
</script>
<style lang="scss" scoped>
  #uploader {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/SimpleUpload.vue